import { getRouter } from '@/router'
import store from '@/store'
import { getApp } from '@/main'
import { debounce } from 'lodash'
import { mapGetters } from 'vuex'
import { subAppUrlToBaseUrl } from '.'
import { getBaseAppProtocolHost, getIframeContentWindowByTagId, isAppInnerUrl, isSamePageTagByUrl, routerChangeTrigger } from './utils'

import { navigate } from './utils/navigator'

export function setTagTitle(payload) {
  store.dispatch('pageTag/setTagTitle', payload)
}

export async function addPageTagAndNavigateBySubAppUrl(fullUrl, title, options = {}) {
  const ifAppInnerUrl = isAppInnerUrl(fullUrl)
  if (!ifAppInnerUrl) {
    window.open(fullUrl)
    return
  }

  const baseAppUrl = subAppUrlToBaseUrl(fullUrl || '')
  addPageTagAndNavigate(baseAppUrl, title, options)
}

export async function addPageTagAndNavigate(fullUrl, title, options = {}) {
  console.log('base-app addPageTagAndNavigate fullUrl', fullUrl)
  // strict = url 严格判断
  const { strict = true, strictToEnd = false, mustNew = false, parentTagId } = options

  if (!fullUrl) {
    console.error('addPageTagAndNavigate 没有提供fullUrl')
    return
  }

  // todo url 不属于本应用(base + sub), 直接跳转

  // 新增一个 pagTag
  const tag = await store.dispatch('pageTag/addPageTag', {
    strictToEnd,
    strict,
    mustNew,
    title,
    url: fullUrl,
    parentTagId,
  })

  await setActiveTagAndNavigate(tag)
}

export async function setActiveTagAndNavigate(tag) {
  console.log('setActiveTagAndNavigate')

  if (!tag || !tag.id) {
    return
  }

  const curActiveTagId = store.state.pageTag.activeTagId
  if (curActiveTagId === tag.id) {
    console.log(`targetTagId is same to curActiveTagId:  targetTagId: ${tag.id} curActiveTagId: ${curActiveTagId}, `)
    return
  }

  await store.dispatch('pageTag/setActiveTagId', tag.id)

  // 让 PageTagList 先渲染, 稍后处理下方显示的 iframe
  await Promise.resolve()

  // 跳转
  const fullUrl = tag.urlLatest
  if (fullUrl === window.location.href) {
    // 不会触发 router.afterEach, 要手动补偿一下
    await store.dispatch('pageTag/postActions')
  }
  navigate(fullUrl)
}

export async function removePageTagAndBackward(tag) {
  if (!tag.closeable) {
    throw new Error('这个 tag 不允许删除')
  }

  const pageTags = store.state.pageTag.pageTags
  const activeTag = store.getters['pageTag/activeTag']
  const activeTagIndex = store.getters['pageTag/activeTagIndex']
  let nextPosTag

  if (activeTag.id === tag.id) {
    // 如果删除的页签是 active 的, 那需要找到下一个 active 的页签
    // 删除的就是 active的
    const nextPos = activeTagIndex + 1 === pageTags.length ? activeTagIndex - 1 : activeTagIndex + 1
    nextPosTag = pageTags[nextPos]
  }

  store.dispatch('pageTag/removeTag', tag)

  if (nextPosTag) {
    setActiveTagAndNavigate(nextPosTag)
  } else {
    store.dispatch('pageTag/fixTagPosition')
  }
}

export async function removeOtherTags(tag) {
  // 新增一个 pagTag
  store.dispatch('pageTag/removeOtherTags', tag)
  store.dispatch('pageTag/fixTagPosition')
}

export async function pinTag(tag) {
  // 新增一个 pagTag
  store.dispatch('pageTag/pinTag', tag)
  store.dispatch('pageTag/fixTagPosition')
}

export async function cancelPinTag(tag) {
  // 新增一个 pagTag
  store.dispatch('pageTag/cancelPin', tag)
  store.dispatch('pageTag/fixTagPosition')
}

export const setHeaderWidth = debounce(function(width) {
  console.log('pageTagUtils setHeaderWidth')
  const DEFAULT_HEADER_WIDTH = 1080
  store.dispatch('pageTag/setHeaderWidth', width || DEFAULT_HEADER_WIDTH)
  store.dispatch('pageTag/fixTagPosition')
}, 300)

/**
 * 通过 url 找对应页签, 一定是同一个
 * @param {*} url
 * @returns
 */
export function findTagByUrl(url, options = {}) {
  const { strictToEnd = false } = options
  if (strictToEnd) {
    console.warn('bae-app 使用strictToEnd 匹配 tag url, 可能出现两个业务类型相同的页签, 比如 订单详情')
  }
  const pageTags = store.state.pageTag.pageTags || []
  return pageTags.find(item => {
    return isSamePageTagByUrl(item.urlLatest, url, { strictToEnd })
  })
}

export function findTagByUrlTolerant(url, title) {
  // 先找严格相等的页签
  const t0 = findTagByUrl(url)
  if (t0) {
    return t0
  }

  // 找 初始 url 相同的页签
  const pageTags = store.state.pageTag.pageTags || []
  const t1 = pageTags.find(item => {
    return isSamePageTagByUrl(item.url, url)
  })
  if (t1) {
    return t1
  }

  // 找 title 相同的页签
  const t2 = pageTags.find(item => {
    return !!title && item.title === title
  })
  if (t2) {
    return t2
  }

  return undefined
}

// 切换到 首页
export function navigateToErpHome() {
  const erpHomeTag = store.state.pageTag.pageTags[0]
  setActiveTagAndNavigate(erpHomeTag)
}

export function syncRouteToBaseApp(data) {
  const baseAppUrl = subAppUrlToBaseUrl(data.fullPath)
  const tagId = data.tagId

  // 先改变 源页签的urlLatest
  store.dispatch('pageTag/setUrlLatest', {
    tag: { id: tagId },
    url: baseAppUrl
  })

  if (store.state.pageTag.activeTagId === tagId) {
    // 如果 tagId 对应的是 activeTagId 那么 需要导航到该页面
    // 信息更新回发生在 router.afterEach
    console.log('base-app syncRouteToBaseApp 更新的是activeTag baseAppUrl', baseAppUrl)
    const baseAppFullPath = baseAppUrl.replace(new RegExp(getBaseAppProtocolHost()), '')
    // 标识本次更新是 s 触发的, base-app 不会展示进度条
    routerChangeTrigger.setTriggerSubApp()
    getRouter().push(baseAppFullPath)
  }
}

export async function goLoginPage(fullPayload = {}) {
  // 忽略bi子应用登出的请求
  const { tagId } = fullPayload
  const tag = findTagById(tagId)
  if (tag) {
    if (tag?.microAppConfig?.ignoreLogoutReq === true) {
      // 忽略登出请求，给出友好提示
      console.warn(`[base-app]goLoginPage: ignoreLogoutReq sub-app-name: [${tag?.microAppConfig?.name}]`)
      // 加上一个防抖
      elMessageBiBusyDebounce()
      return
    }
  }

  // 把所有页签 loaded 状态去掉
  await store.dispatch('pageTag/resetTagLoaded')
  // 重定向到 login-page
  getRouter().push({ name: 'login' })
}

/**
 *
 * @param {*} options { tagId }
 */
export async function tagCloseSelf(options) {
  // 关闭自己
  store.dispatch('pageTag/removeTag', { id: options.tagId })
}

export const messageWrapper = (options = {}) => {
  getApp().$message(options)
}

export function findTagById(tagId, options = {}) {
  const defaultOptions = {
    includeClosed: false
  }
  const optionsFinal = {
    ...defaultOptions,
    ...options,
  }

  let list = store.state.pageTag.pageTags
  if (optionsFinal.includeClosed) {
    list = [
      ...list,
      ...store.state.pageTag.pageTagsClosed,
    ]
  }

  return list.find(item => item.id === tagId)
}

export async function showParentTag(curTagId, options = {}) {
  const { fullUrl } = options
  const curTag = findTagById(curTagId, { includeClosed: true })
  const parentTagId = curTag?.parentTagId
  if (!parentTagId) {
    console.warn(`showParentTag 该页签是由框架打开的,无法showParentTag curTagId: ${curTagId}, 直接打开第一个页签`)
    setActiveTagAndNavigate(store.state.pageTag.pageTags[0])
    return
  }
  const parentTag = findTagById(parentTagId, { includeClosed: false })

  if (parentTag) {
    setActiveTagAndNavigate(parentTag)
  } else if (!parentTag && fullUrl) {
    console.warn('showParentTag !parentTag && fullUrl, 使用url新添加一个页签')
    addPageTagAndNavigateBySubAppUrl(fullUrl, '', options)
  } else {
    console.warn('showParentTag !parentTag && !fullUrl, 打开第一个页签')
    setActiveTagAndNavigate(store.state.pageTag.pageTags[0])
  }
}

export function getParentTag(curTagId, includeClosed = false) {
  const curTag = findTagById(curTagId, { includeClosed: true })
  const parentTagId = curTag?.parentTagId
  if (!parentTagId) {
    console.warn(`getParentTag(): 该页签是由框架打开的,无法 curTagId: ${curTagId}`)
    return
  }
  const parentTag = findTagById(parentTagId, { includeClosed })
  return parentTag
}

export async function postMessageToParentTag(curTagId, payload, options = {}) {
  const parentTag = getParentTag(curTagId, false)
  if (!parentTag) {
    console.warn('postMessageToParentTag(): 未找到parentTag')
    return
  }

  const contentWindow = getIframeContentWindowByTagId(parentTag.id)
  if (contentWindow) {
    contentWindow.postMessage(payload, '*')
  } else {
    console.warn('postMessageToParentTag(): 未找到 parentTag 的 contentWindow')
  }
}

/**
 * pageTag 里面的logout 逻辑
 * 主要是清空页签数据
 */
export async function pageTagLogout() {
  await store.dispatch('pageTag/logout')
}

const elMessageBiBusyDebounce = debounce(function(options) {
  getApp().$message.warning('登录失效，请刷新页面')
}, 5000)
